import React from 'react';

import { defineMessages, T } from '@sm/intl';
import { Typography } from '@sm/wds-react';

import SearchBox from '../../../../components/SearchBox';
import './jumbo-header.scss';

const COPY = defineMessages({
  JUMBO_TAGLINE: {
    id: 'Home.JumboHeader.Tagline',
    defaultMessage: "We're better together",
    description:
      '[Type: Header][Vis.: high] - The main tagline for the home page'
  },
  JUMBO_SUBTITLE: {
    id: 'Home.JumboHeader.Subtitle',
    defaultMessage:
      'Integrate with over 100+ SurveyMonkey apps and plug-ins to get more done',
    description:
      "[Type: Header][Vis.: high] - A small description of what's available on the app directory page"
  }
});

const JumboHeader = () => {
  return (
    <div
      data-testid="AppsDirectory_JumboHeader"
      className="sm-jumbo-header wds-flex wds-flex--y wds-flex--y-center wds-p-l-5 wds-p-r-5"
    >
      <Typography
        variant="hero1"
        component="h1"
        color="light"
        className="sm-jumbo-header__title"
      >
        <T desc={COPY.JUMBO_TAGLINE} />
      </Typography>
      <Typography
        variant="cardTitle"
        component="div"
        color="light"
        className="sm-jumbo-header__subtitle"
      >
        <T desc={COPY.JUMBO_SUBTITLE} />
      </Typography>
      <div className="sm-jumbo-header__search-box-wrapper wds-m-t-4">
        <SearchBox />
      </div>
    </div>
  );
};

export default JumboHeader;
